module.exports = __webpack_public_path__ + "static/google-partner-59b39dce3cc50acfdee1a8d8f91282d2.svg";